"use strict";
function not(pred, thisArg) {
    function notPred() {
        return !(notPred.pred.apply(notPred.thisArg, arguments));
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
exports.not = not;
//# sourceMappingURL=not.js.map


//////////////////
// WEBPACK FOOTER
// /root/anvel/~/rxjs/util/not.js
// module id = ../../../../rxjs/util/not.js
// module chunks = 4